import "./polyfill/closest_polly";

import "./functions/vhsp";
import "./functions/viewport";
import "./functions/touch-hover";
import "./functions/accordion";
import "./functions/header";
import "./functions/smooth";
import "./functions/page-top";
import "./functions/more-switch";

import "./Libs/animation";
import "./Libs/parallax";
import "./Libs/lightbox";
import "./Libs/scrollable";
